<template>
  <div class="sidebar">
    <el-menu
      class="sidebar-el-menu collect-opera"
      :default-active="onRoutes"
      :collapse="collapse"
      unique-opened
      :default-openeds="defaultopenmenu"
    >
      <div
        class="open_sidebar"
        @click="CollapseChange"
      >
        <i class="iconfont text_btn">{{ collapse ? "展开" : "收起" }}</i>
        <span
          class="iconfont icon-shouqi1"
          :class="collapse ? 'trans' : ''"
          v-show="true"
        ></span>
      </div>
      <template v-for="item in items">
        <template v-if="item.subs">
          <el-submenu
            :index="item.pid + '/' + item.title + '/' + item.id"
            :key="item.title"
          >
            <template #title>
              <img
                v-if="item.icon!=''"
                :src="getImageUrl(item.icon)"
                class="iconfont"
              />
              <i
                v-else
                class="iconfont icon-morencaidan"
              ></i>
              <span>{{ item.title }}</span>
            </template>

            <template
              v-for="(subItem, subItemindex) in item.subs"
              :key="subItemindex"
            >
              <el-menu-item
                :index="subItem.title"
                @click="collect(subItem, $event)"
              >
                <span
                  data-type="path"
                  :data-index="
                    subItem.pid + '/' + subItem.title + '/' + subItem.id
                  "
                  :title="subItem.title"
                  class="menu_title"
                >
                  <i class="custom-icon el-icon-d-arrow-right"></i>{{ subItem.title }}</span>
              </el-menu-item>
            </template>
          </el-submenu>
        </template>
      </template>
    </el-menu>
  </div>
</template>

<script>
import menus from "@/util/menus.js";
import { mapMutations } from "vuex";
import Enumerable from "linq";
export default {
  data() {
    return {
      cursorState: true, //鼠标是否浮上去
      collapse: false,
      iconlist: [
        { id: "OOguanli", value: "icon-OOguanli" },
        { id: "jichudanganguanli", value: "icon-jichudanganguanli" },
        { id: "biaodanyemian2", value: "icon-biaodanyemian2" },
        { id: "baobiao", value: "icon-baobiao" },
      ],
      searchInput: "", //搜索
      focusState: false,
      flag: 0,
      searchState: false, //搜索遮罩层
      otherState: false, //菜单除一级之外的浮层
      searchStateQh: true,
      newestSlider: false, //左侧是否显示 默认显示
      menuItems: [],
      items: [],
      oneMenuItemid: "", // 二级菜单的ID
      secondMenuItemid: "", //三级菜单
      checkid: "", // 选中的菜单
      isSearch: false, // 搜索的 hover 状态
      searchArr: [],
      isStar: false,
      defaultopenmenu: [],
    };
  },
  mounted() {},
  created() {
    // 通过 Event Bus 进行组件间通信，来折叠侧边栏
    this.emitter.on("collapse", (msg) => {
      this.collapse = msg;
    });
    this.emitter.on("tags", (msg) => {
      this.tagsList = msg;
    });
    this.request();
  },
  methods: {
    ...mapMutations(["setCollapse"]),
    collect(fourItem, event) {
      let routerObj = {
        name: fourItem.title,
        path: `${fourItem.path}`,
      };
      this.$router.push(routerObj);
    },
    CollapseChange() {
      this.collapse = !this.collapse;
      this.setCollapse(this.collapse);
      this.emitter.emit("collapse", this.collapse);
    },
    // 左侧点击事件
    onemenuBtn(way, topMenuItem) {
      this.flag = 1;
      this.$emit("bgStateOpen");
      if (way == 1) {
        this.searchState = true;
        this.otherState = false;
        this.searchStateQh = true;
        this.searchInput = "";
      } else {
        this.oneOperaMenu(topMenuItem.id, topMenuItem.title);
      }
    },
    setItemValBytitle(arr, item, func) {
      //先处理当前对象
      let dataInternational = arr.find((obj) => {
        return obj.BSNAME.trim() == item.title.trim().replace(" ", "");
      });
      if (dataInternational != undefined) {
        item.title = dataInternational.BSMEAN;
      }
      //当前对象有没有子集 有的话递归自己
      if (item.subs && item.subs != null) {
        for (let la in item.subs) {
          func(arr, item.subs[la], func);
        }
      }
    },
    // 获取菜单
    request() {
      // localStorage.setItem("mainList", JSON.stringify(mainList));
      // if (mainList != null && typeof mainList != "undefined") {
      //   this.setDefImg(mainList);
      // }
      let menulist = menus;
      localStorage.setItem("menus", JSON.stringify(menulist));
      if (menulist != null && typeof menulist != "undefined") {
        this.setMenu(menulist);
      }
    },
    setMenu(menulist) {
      // let menu_first = menulist.filter((item) => {
      //   return item.pid == "100";
      // });
      let isAdmin = sessionStorage.getItem("UserID").toUpperCase() == "ADMIN";
      let permissions = [];
      if(sessionStorage.getItem("userPermissions")) {
        permissions = JSON.parse(sessionStorage.getItem("userPermissions"));
      }
      let menu_first = []
      if(!permissions.includes("CourseManagement.CourseList")) {
        menu_first = Enumerable.from(menulist).where(item => item.pid == "100" && item.id !='FM10000').orderBy(item => item.order).toArray();
      } else {
        menu_first = Enumerable.from(menulist).where(item => item.pid == "100").orderBy(item => item.order).toArray();
      }
      // let menu_first = Enumerable.from(menulist).where(item => item.pid == "100").orderBy(item => item.order).toArray();
      let menuList = [];
      menu_first.forEach((item) => {
        let minimenu = item;
        // minimenu.subs = menulist.filter((menu) => {
        //   return menu.pid == item.id;
        // });
        minimenu.subs = Enumerable.from(menulist)
                                  .where(menu => menu.pid == item.id 
                                    && (isAdmin || permissions.includes(menu.pathName) || permissions.includes(menu.pathName+'View'))
                                    )
                                  .orderBy(menu => menu.order)
                                  .toArray();
        if(minimenu.subs.length > 0 || (minimenu.subs.length == 0 && minimenu.pathName != "")) {
          menuList.push(minimenu);
        }
      });
      this.setDefImg(menuList);
    },
    // 设置默认图片
    setDefImg(data) {
      this.items = data;
      this.items.forEach((item) => {
        this.addDataL(item);
      });
      // this.iconfontShow();
    },
    getImageUrl(name) {
      return require(`../../assets/images/${name}.png`);
    },
    //鼠标移入事件
    mouseoverBtn(way, topMenuItem) {
      if (this.flag == 1) {
        if (way == 1) {
          this.searchState = true;
          this.otherState = false;
          this.checkid = "";
          this.isSearch = true;
        } else {
          this.isSearch = false;
          this.checkid = topMenuItem.id;
          this.oneOperaMenu(topMenuItem.id, topMenuItem.title);
        }
      } else {
        if (way == 1) {
          this.isSearch = true;
        }
        if (topMenuItem && topMenuItem.id) {
          this.checkid = topMenuItem.id;
        }
      }
    },
    //鼠标移出事件
    mouseleaveBtn() {
      if (this.flag !== 1) {
        this.checkid = "";
        this.isSearch = false;
      }
    },
    addDataL(item, key) {
      if (item.lv >= 4) return;
      if (key) {
        item.lv = key.lv + 1;
        item.findName = `${key.findName} > ${item.title}`;
      } else {
        item.lv = 1;
        item.findName = item.title;
      }
      if (item.lv < 4 && !item.subs) {
        const data = Object.assign({}, item);
        data.lv++;
        item.subs = [data];
      }
      const subs = item.subs;
      if (subs && subs.length > 0) {
        subs.forEach((i) => {
          this.addDataL(i, item);
        });
      }
    },
    iconfontShow() {
      let that = this;
      for (var i in that.items) {
        var iconflag = "icon-morencaidan";
        for (var j in that.iconlist) {
          if (that.items[i].icon == that.iconlist[j].id) {
            iconflag = that.iconlist[j].value;
          }
        }
        that.items[i]["confontindex"] = iconflag;
      }
    },
    //实际 打开菜单
    oneOperaMenu(id, title) {
      this.otherState = true;
      this.searchState = false;
      this.oneMenuItemid = id;
      this.secondMenuItemid = "";
    },
    oneMenuItemFilter(oneMenuItemid) {
      if (oneMenuItemid) {
        let subItems = this.items.filter((item) => item.id === oneMenuItemid)[0]
          .subs;
        return subItems;
      } else {
        return [];
      }
    },
    // 点击左侧跳转
    menuCollect(fourItem, $event, way) {
      if ($event.target.dataset.type == "path") {
        this.otherState = false;
        this.flag = 0;
        this.$emit("bgStateClose");
        let routerObj = {
          name: fourItem.title,
          path: `${fourItem.path}`,
        };
        this.$router.push(routerObj);
        this.searchState = false;
      }
    },
    // 弹框封装
    showMessage(text, status) {
      if (status === "success") {
        this.$message({
          message: text,
          type: "success",
        });
      } else {
        this.$message.error(text);
      }
    },
  },
  computed: {
    onRoutes() {
      return this.$route.name;
    },
    resetHtml(data) {
      return function (data) {
        let reg = new RegExp("(" + this.searchInput.toUpperCase() + ")", "g");
        return data.replace(reg, "<span style='color: #2d8cf0;'>$&</span>");
      };
    },
  },
};
</script>

<style lang="scss">
#sider {
  width: 208px;
  height: 100vh;
  background-color: #fff;
}
</style>
<style scoped>
/* custom menu修改 */
.custom-icon {
  font-size: 14px;
  margin-right: 8px;
  vertical-align: unset;
  font-weight: 500;
}
.sidebar .el-submenu.is-opened .iconfont {
  color: #0747a6;
}
.el-submenu.is-opened .el-submenu__title > span {
  color: #0747a6;
  font-weight: 500;
}
.el-submenu .el-submenu__title > span {
  color: #262a33;
}
.el-submenu .el-menu-item.is-active {
  background-color: #e6f7ff;
  border-right: 4px solid #0747a6;
}
.el-submenu .el-menu-item.is-active > span {
  background-color: #e6f7ff;
  color: #0747a6;
}

@import "../../common/newmenu/newmenu.css";
.layermenu_search /deep/ .el-input {
  display: inline-block;
  vertical-align: top;
  width: 576px;
  height: 40px;
}
.layermenu_search /deep/ .el-input .el-input__inner {
  height: 40px;
  border-radius: 0;
  border: 0;
  background: transparent;
  padding-left: 0;
}
.layermenu_search /deep/ .el-button {
  display: inline-block;
  vertical-align: top;
  width: 136px;
  height: 40px;
  border-radius: 0 4px 4px 0;
  font-size: 14px;
}
.searchsj {
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  color: #2d8cf0;
  margin-left: 10px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
.open_sidebar.switch_home {
  height: 56px;
  line-height: 56px;
}
.open_sidebar.switch_home .icon-caidan,
.open_sidebar .text_btn {
  height: 56px;
  line-height: 56px;
  padding-right: 10px;
}
.open_sidebar .iconfont.icon-shouqi1 {
  height: 56px;
  line-height: 56px;
  display: inline-block;
}
.open_sidebar.switch_home .home_title {
  height: 56px;
  line-height: 56px;
}
.sidebar {
  display: block;
  position: absolute;
  left: 0;
  top: 60px;
  bottom: 0;
  overflow-y: scroll;
}
.sidebar .open_sidebar:hover {
  color: rgb(191, 203, 217);
  /* background-color: rgb(40, 52, 70); */
}
.sidebar .open_sidebar {
  height: 56px;
  line-height: 56px;
  position: relative;
  -webkit-box-sizing: border-box;
  white-space: nowrap;
  list-style: none;
  font-size: 12px;
  color: #303133;
  padding: 0 10px;
  cursor: pointer;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: rgb(191, 203, 217);
  /* background-color: rgb(50, 65, 87); */
  overflow: hidden;
}
.sidebar .switch_home.open_sidebar {
  padding: 0 20px;
}
.sidebar .switch_home.open_sidebar .iconfont {
  font-size: 16px;
}
.sidebar .open_sidebar .iconfont {
  color: #909399;
  /* font-size:18px;  */
}
.sidebar .open_sidebar .iconfont.icon-shouqi1 {
  width: auto;
  height: auto;
  color: #909399;
  margin: 0;
  font-size: 12px;
  transform: rotateZ(270deg);
  transition: all 0.25s linear;
}
.sidebar .open_sidebar .iconfont.icon-shouqi1.trans {
  transform: rotateZ(90deg);
}
.sidebar .open_sidebar .iconfont.text_btn {
  color: #909399;
  font-size: 12px;
  margin-right: 0;
}
.sidebar .iconfont {
  height: 22px;
  width: 20px;
  font-size: 18px;
  margin-right: 6px;
  display: inline-block;
  line-height: 1;
  color: #262a33;
}

.sidebar::-webkit-scrollbar {
  width: 0;
}

.sidebar .sidebar-el-menu:not(.el-menu--collapse) {
  width: 250px;
}

.sidebar > ul {
  height: 100%;
}
/* sj */

/* .sidebar .sidebar-el-menu {
  background-color: #324157;
} */
.sidebar .el-submenu .el-menu-item {
  color: rgb(50, 65, 87);
  /* background-color: rgb(50, 65, 87); */
}
.sidebar .el-submenu .el-menu-item:hover {
  /* background-color: rgb(40, 52, 70); */
}
.sidebar .el-submenu__title {
  color: rgb(50, 65, 87);
  /* background-color: rgb(50, 65, 87); */
}
.sidebar .el-submenu__title:hover {
  color: rgb(191, 203, 217);
  background-color: rgb(40, 52, 70);
}
.el-menu {
  border-right-width: 0;
}
.sidebar > ul {
  height: 90%;
}
.sidebar .switch {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 10%;
  font-size: 14px;
  color: #6383b3;
  cursor: pointer;
  background-color: rgb(50, 65, 87);
  border-right-width: 0;
  transition: border-color 0.3s, background-color 0.3s, color 0.3s;
}
.switch img {
  width: 15px;
  height: 15px;
  margin-right: 5px;
}
.switch-btn {
  margin-left: 50px;
}
.switch-btn-default {
  margin-left: 20px;
}
.el-submenu .el-menu-item {
  overflow: hidden;
}

.sidebar .sidebar-el-menu:not(.el-menu--collapse) {
  transition: border-color 0.3s, background-color 0.3s, color 0.3s;
}
.open_sidebar {
  transition: border-color 0.3s, background-color 0.3s, color 0.3s;
}
.menu_title {
  display: inline-block;
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.menu_collect {
  display: inline-block;
  width: 38px;
  font-weight: normal;
  font-size: 13px;
  margin-left: 10px;
  color: #409eff;
}
.menu_collect:hover,
.collect_cancel {
  text-decoration: underline;
}
.menu_title,
.collect_title {
  display: inline-block;
  max-width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  font-style: normal;
}
.sidebar .menu_collect,
.sidebar .collect_cancel {
  display: inline-block;
  font-weight: normal;
  font-size: 15px !important;
  vertical-align: middle;
  height: 50px !important;
  line-height: 50px !important;
  text-align: right;
}
.sidebar .icon-shoucangjia,
.el-menu--popup-right-start .icon-shoucangjia {
  color: #acb3bc;
}
.sidebar .icon-weishoucang,
.el-menu--popup-right-start .icon-weishoucang {
  color: #adb4bd;
}
.sidebar .ourstitle {
  color: #778393;
}
.el-menu--popup-right-start .menu_title,
.el-menu--popup-right-start .collect_title {
  color: #778393;
}
.el-submenu__title .ours-collect {
  color: #909399;
}
.collect-opera .el-menu-item {
  position: relative;
}
.sidebar .iconfont {
  /* height: 20px;
    width: 24px;
    font-size: 18px;
    margin-right: 6px;
    display: inline-block;
    line-height: 1; */
}
.sidebar .arrowtip {
  position: absolute;
  right: 20px;
  color: #c6d0dc;
  margin-right: 0;
  width: 0;
  height: 0;
  border-right: 5px solid transparent;
  border-left: 5px solid transparent;
}
.sidebar .arrowup {
  top: 17px;
  border-bottom: 7px solid #c6d0da;
}
.sidebar .arrowup:not(.noarrowup):hover {
  border-bottom: 7px solid #acb3bc;
}
.sidebar .arrowdown {
  bottom: 15px;
  border-top: 7px solid #c6d0da;
}
.sidebar .arrowdown:not(.noarrowdown):hover {
  border-top: 7px solid #acb3bc;
}
.sidebar .noarrowup {
  border-bottom: 7px solid #dfe5ed !important;
}
.sidebar .noarrowdown {
  border-top: 7px solid #dfe5ed !important;
}
.el-menu--vertical .el-menu--popup {
  padding: 0;
}
</style>


